
import { RegistrationSearchItem } from "@/models";
import { defineComponent, PropType } from "vue";
export default defineComponent({
  props: {
    dataItem: Object as PropType<RegistrationSearchItem>,
  }
});
